module.exports = __webpack_public_path__ + "img/mail.ab986707.png";